module.exports = __webpack_public_path__ + "img/szwyh.173b2e5c.jpg";